import isNull from 'lodash/isNull';
import classNames from 'classnames';
import React, { PropTypes, PureComponent } from 'react';
import ReactCssTransitionGroup from 'react-addons-css-transition-group';
import ReactImmutablePropTypes from 'react-immutable-proptypes';
import { connectToStores } from 'fluxible-addons-react';
import Button from '../Button';
import Spinner from '../Spinner';
import { modal } from '../Modal';
import ModalResult from '../ModalResult';
import Events from '../../utils/Events';
import { withStyle } from '../../utils/Decorator';

const INTRO = {
  0: 'START',
  1: 'LOGIN',
  2: 'GENERATE',
  3: 'GENERATED',
  4: 'MAEOKI',
  5: 'KAIWA1',
  6: 'PARTNER',
  7: 'PARTNERSHARE',
  8: 'KAIWA2',
  9: 'TENCHOSHARE',
};

@withStyle(require('./Intro.styl'))
@connectToStores(['UserStore'], (context) => ({
  account: context.getStore('UserStore').getAccount(),
}))
export default class Intro extends PureComponent {
  static propTypes = {
    game: PropTypes.object,
    onEnd: PropTypes.func.isRequired,
    staffs: PropTypes.array.isRequired,
    account: ReactImmutablePropTypes.map.isRequired,
  };

  static defaultProps = {
    staffs: [],
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.effectTime = 480;
    this.events = new Events();
    const bgmEnabled = localStorage.getItem('app:bgm');
    this.state = { scene: 0, subscene: 0, clickable: true, bgmEnabled: isNull(bgmEnabled) ? true : bgmEnabled === '1' };
    localStorage.setItem('app:bgm', this.state.bgmEnabled ? '1' : '0');
  }

  componentDidMount = () => {
    twttr.widgets.load(this.node.querySelector('.twitter-moment'));
  };

  handleShowResult = () => {
    modal(ModalResult, { game: this.game, ended: true });
  };

  handleAssignNode = (node) => {
    this.node = node;
  };

  renderButton = ({ message, onClick = this.handleNextScene, disabled = false }) => (
    <div className='intro-button'>
      <Button size='intro' onClick={onClick} disabled={disabled || !this.state.clickable}>
        <span className={classNames({ visible: this.state.clickable })}>{message}</span>
        {!this.state.clickable && <Spinner white />}
      </Button>
    </div>
  );

  render = () => (
    <div id='Intro' ref={this.handleAssignNode}>
      <ReactCssTransitionGroup transitionName='welcome' transitionEnterTimeout={this.effectTime} transitionLeaveTimeout={this.effectTime}>
        <div id='IntroContent' className={INTRO[this.state.scene]} key={this.state.scene}>
          <img src='/images/main.png' className='logo' role='presentation' />
          <div className='about'>
            <a href='http://touch.pixiv.net/info.php?id=3909' rel='noopener noreferrer' target='_blank'>
              みんなのpixivコミックストアとは？
            </a>
          </div>
          <div className='info'>
            <div>みんストは2017/1/8をもって終了しました</div>
          </div>
          <div className='twitter'>
            <a className='twitter-moment' href='https://twitter.com/i/moments/813285305532854272'>みんなのpixivコミックストア</a>
          </div>
          <Button type='ui' ui='left2' onClick={this.handleShowResult}>
            <img src='/images/icon_hakusyo.png' role='presentation' />
            <div className='label'>書店白書</div>
          </Button>
        </div>
      </ReactCssTransitionGroup>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/components/Intro/Intro.jsx